import { inject, Injectable } from '@angular/core';
import { HttpClient, httpResource } from '@angular/common/http';
import { environment } from '@app/env';
import { Employee, EmployeeVacancyApplication } from '@app/shared/models';

export type EmployeeContract = {
  id: string;
  companyName: string;
  dateFrom: string;
  dateTo: string;
};

export type EmployeePaycheck = {
  documentId: string;
  fileName: string;
  fileSize: string;
  dateCreated: string;
};

@Injectable({ providedIn: 'root' })
export class EmployeeApiService {
  readonly #http = inject(HttpClient);
  readonly #EMPLOYEES_API_BASE_URL = `${environment.apiBaseUrl}/employees`;

  getEmployeeContractsResource(employeeId: string) {
    return httpResource<EmployeeContract[]>(
      () => `${this.#EMPLOYEES_API_BASE_URL}/${employeeId}/documents/contracts`,
    );
  }

  getEmployeePaychecksResource(employeeId: string) {
    return httpResource<EmployeePaycheck[]>(
      () => `${this.#EMPLOYEES_API_BASE_URL}/${employeeId}/documents/payslips`,
    );
  }

  updateEmployee(employeeId: string, employeeData: Employee) {
    return this.#http.put<Employee>(
      `${environment.apiBaseUrl}/users/${employeeId}/profile`,
      employeeData,
    );
  }

  applyToVacancy(employeeId: string, employee: EmployeeVacancyApplication) {
    return this.#http.post<EmployeeVacancyApplication>(
      `${this.#EMPLOYEES_API_BASE_URL}/${employeeId}/vacancies`,
      employee,
    );
  }
}
